import React, { useContext, useEffect, useState } from "react";
import { HashLink } from "react-router-hash-link";
import { AppContext } from "../../Contexts/AppContext";

const Hero = () => {
  const context = useContext(AppContext);
  const [currentBG, setCurrentBG] = useState("");
  const [currentText, setCurrentText] = useState("");
  const [currentColor, setCurrentColor] = useState("");

  useEffect(() => {
    setCurrentBG(
      context.isLight
        ? context.currentTheme["default"].bg
        : context.currentTheme["default"].dark_bg
    );
    setCurrentText(
      context.isLight
        ? context.currentTheme["default"].text
        : context.currentTheme["default"].dark_text
    );
    setCurrentColor(
      context.isLight
        ? context.currentTheme["default"].dark_dropdown
        : context.currentTheme["default"].dropdown
    );
  }, [context]);

  return (
    <div
      className="flex min-h-[calc(100vh-56px)] w-screen flex-col justify-center px-[5%] pt-8 transition-all duration-500 xs:px-[10%] md:flex-row lg:pt-12"
      style={{ backgroundColor: currentBG, color: currentText }}
    >
      <div className="basis-1/4 lg:basis-1/2">
        <p className="font-thin">A TRUSTED DIGITAL AGENCY</p>
        <h1 className="mt-1 mb-3 text-4xl font-bold xs:mt-2 xs:mb-5 xs:text-5xl ss:text-6xl">
          We make your business look amazing
        </h1>
        <p className="max-w-screen-xs">
          Centralized Platform is a digital studio that offers several services
          such as UI/UX Design to developers, we will provide the best service
          fot those of you who use our services
        </p>
        <div className="mb-5 flex lg:mb-10">
          <HashLink
            to="/#services"
            smooth
            className="my-2 rounded-xl border-2 p-2 text-base font-semibold transition-all xs:my-5 xs:py-2 xs:px-4 xs:text-xl"
            style={{ backgroundColor: currentColor, color: currentBG }}
            onMouseEnter={(e) => {
              e.target.style.borderColor = "unset";
              e.target.style.backgroundColor = "unset";
              e.target.style.color = "unset";
            }}
            onMouseLeave={(e) => {
              e.target.style.borderColor = currentColor;
              e.target.style.backgroundColor = currentColor;
              e.target.style.color = currentBG;
            }}
          >
            Get Started
          </HashLink>
        </div>
        <div className="mx-auto flex w-fit md:m-0 md:w-auto">
          <section className="p-2 xs:p-3 ss:p-4 lg:p-5">
            <h2 className="text-2xl font-bold xs:text-3xl lg:text-4xl">100+</h2>
            <p className="text-base font-thin xs:text-xl lg:text-2xl">CLIENT</p>
          </section>
          <section className="p-2 xs:p-3 ss:p-4 lg:p-5">
            <h2 className="text-2xl font-bold xs:text-3xl lg:text-4xl">40</h2>
            <p className="text-base font-thin xs:text-xl lg:text-2xl">
              STARTUP
            </p>
          </section>
          <section className="p-2 xs:p-3 ss:p-4 lg:p-5">
            <h2 className="text-2xl font-bold xs:text-3xl lg:text-4xl">40</h2>
            <p className="text-base font-thin xs:text-xl lg:text-2xl">
              PRODUCT
            </p>
          </section>
        </div>
      </div>

      <div className="hidden basis-3/4 md:block lg:basis-1/2">
        <img
          src={
            context.isLight
              ? `${process.env.REACT_APP_IMAGES_URL}/Assets/Logo/logo-light.png`
              : `${process.env.REACT_APP_IMAGES_URL}/Assets/Logo/logo-dark.png`
          }
          className="w-full"
          alt="website logo"
        />
      </div>
    </div>
  );
};

export default Hero;
